import React from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle, Box } from '@availity/element';
import { getSpecificEnv } from '@availity/env-var';

const currentEnv = getSpecificEnv();
const isProdEnv = currentEnv === 'prod';

const bootstrapBannerColors = ['success', 'danger', 'warning', 'info'];

const getColor = (colorValue) => {
  const lowercaseColorValue = colorValue?.toLowerCase();

  if (bootstrapBannerColors.indexOf(lowercaseColorValue) >= 0) {
    return lowercaseColorValue;
  }

  let output;
  switch (lowercaseColorValue) {
    case 'red': {
      output = 'error';
      break;
    }
    case 'blue': {
      output = 'info';
      break;
    }
    case 'yellow': {
      output = 'warning';
      break;
    }
    default: {
      // default to green
      output = 'success';
    }
  }

  return output;
};

const NewLoginBanner = ({ toggle, title, body, color = 'success' }) => {
  const colorToUse = getColor(color);

  return (
    <Alert
      severity={colorToUse}
      sx={{
        marginBottom: 0,
        padding: 2,
        maxWidth: '1267px',
      }}
      onClose={!isProdEnv && toggle}
    >
      <AlertTitle>{title}</AlertTitle>
      <Box>{body}</Box>
    </Alert>
  );
};

NewLoginBanner.propTypes = {
  toggle: PropTypes.func,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default NewLoginBanner;
